import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { removeOldestQuery } from "@tanstack/react-query-persist-client";

// Shared cache for server data. Catalog responses are served from the cache the
// moment a page mounts and refreshed in the background once they are older than
// staleTime, so a visitor coming back never waits on the network to see products.
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            gcTime: 24 * 60 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

// Keeps the cache in local storage so it also survives a reload. Bump the
// buster whenever the shape of a cached response changes. Category listings add
// up past the ~5MB local storage quota, so when a save does not fit the oldest
// queries are dropped until it does.
export const queryPersister = createSyncStoragePersister({
    storage: window.localStorage,
    key: "df-query-cache",
    retry: removeOldestQuery,
});

export const QUERY_CACHE_BUSTER = "v1";
export const QUERY_CACHE_MAX_AGE = 24 * 60 * 60 * 1000;
